<template lang="pug">
button-base.button-secondary.font-bold(@click='clickEvent')
  slot
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator'
import ButtonBase from '@/components/atoms/ButtonBase.vue'

/**
 * 基本のボタン2
 */
@Component({
  components: {
    ButtonBase,
  },
})
export default class ButtonSecondary extends Vue {
  private clickEvent(key: Event): void {
    this.$emit('click', key)
  }
}
</script>

<style lang="stylus" scoped>
.button-secondary
  height var(--input-height-default)
  padding 10px
  color var(--color-input-secondary__text)
  background-color var(--color-input-secondary__background)
  border-radius 20px

  &[data-disabled='true']
    background-color var(--color-input-primary__background-disabled)
    cursor default
</style>
